import { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import loginLogo from "../../assets/logiscreen.png";
// eslint-disable-next-line no-unused-vars
import { Link, useNavigate } from "react-router-dom";
import api from "../../utils/api";
import { toast } from "react-toastify";
import {
  detectLogin,
  empty,
  setUserdatas,
  showToast,
} from "../../helper/generalHelper";
import ForgotPassword from "./ForgotPassword";
import { FiEye, FiEyeOff } from "react-icons/fi";
// Adjust this import path based on your project

const AuthPage = () => {
  const navigate = useNavigate();
  const [isForgotPasswordOpen, setIsForgotPasswordOpen] = useState(false);

  useEffect(() => {
    // detectLogin(); // Removed as per user request to stop 'automation'
  }, []);

  const location = useLocation();
  const [activeTab, setActiveTab] = useState(
    location.pathname.includes("/login") ? "login" : "signup"
  );

  const [loginData, setLoginData] = useState({
    email_or_mobile: "",
    password: "",
  });

  const [signupData, setSignupData] = useState({
    reg_firstName: "",
    reg_lastName: "",
    reg_mobile: "",
    reg_password: "",
    reg_email: "",
  });

  const [success, setSuccess] = useState("");
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");
  const [errors, setErrors] = useState({});
  const [showPassword, setShowPassword] = useState(false);

  //  ░▒▒▒▒▒▒▒▒▒▒▒▒▒▒  REGISTER ▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒

  const handleSignupChange = (e) => {
    const { name, value } = e.target;

    setSignupData((prev) => ({
      ...prev,
      [name]: value,
    }));

    // Clear field-specific error on change
    setErrors((prev) => ({
      ...prev,
      [name]: "",
    }));
  };

  const handleSignupSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError("");
    setSuccess("");

    // ✅ Basic client-side validation
    const newErrors = {};

    if (!signupData.reg_firstName.trim())
      newErrors.reg_firstName = "First name is required";
    if (!signupData.reg_mobile.trim()) newErrors.reg_mobile = "Mobile is required";
    if (!signupData.reg_password.trim())
      newErrors.reg_password = "Password is required";

    if (Object.keys(newErrors).length > 0) {
      setErrors(newErrors);
      setLoading(false);
      return; // ⛔ Prevent form submission
    }

    const formData = new FormData();
    // Map back to original keys for backend
    const mapping = {
      reg_firstName: "firstName",
      reg_lastName: "lastName",
      reg_mobile: "mobile",
      reg_password: "password",
      reg_email: "email"
    };

    Object.keys(signupData).forEach((key) => {
      formData.append(mapping[key] || key, signupData[key]);
    });

    const headers = { "Content-Type": "application/json" };
    const res = await api.post("restaurant/sign-up", formData, { headers });

    if (res.success) {
      toast.success(res.message || "Account created successfully!");
      setUserdatas(res.data);
      

      if (empty(res.data?.restaurantId)) {
        navigate("/restaurant/addbusiness");
      } else {
        navigate("/restaurant/dashboard");
      }
    } else {
      toast.error(res.message || "Signup failed. Please try again.");
      setError(res.message);
    }

    setLoading(false);
  };

  //  ░▒▒▒▒▒▒▒▒▒▒▒▒▒▒ LOGIN ▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒

  const handleLoginChange = (e) => {
    const { name, value } = e.target;
    setLoginData((prev) => ({ ...prev, [name]: value }));
  };

  // Login Submit
  const handleLoginSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError("");

    const res = await api.post("restaurant/sign-in", loginData, {}, false);
    
    setLoading(false);

    if (res.success) {
      showToast(res);
      setUserdatas(res?.data);

      if (empty(res.data?.restaurantId)) {
        navigate("/restaurant/addbusiness");
      } else {
        navigate("/restaurant/dashboard");
      }
    } else {
      toast.error(res.message || "Login failed. Please check your credentials.");
      setError(res.message);
    }
  };

  return (
    <div className="h-screen w-screen overflow-scroll bg-white md:bg-white">
      {/* ✅ Desktop View */}
      <div className="hidden md:flex flex-row items-center justify-center h-screen p-8 bg-white">
        {/* Left: Logo */}
        <div className="md:w-1/2 w-full md:flex justify-center items-center">
          <img src={loginLogo} alt="Illustration" className="md:w-3/4" />
        </div>

        {/* Right: Form Section */}
        <div className="w-full md:w-1/2 max-w-md">
          {/* Tabs */}
          <div className="flex justify-center gap-4 mb-6">
            <button
              className={`px-4 py-2 font-semibold rounded-t-md ${
                activeTab === "signup"
                  ? "border-b-2 border-primary text-primary"
                  : "border-b-2 border-gray-200 text-gray-600"
              }`}
              onClick={() => setActiveTab("signup")}
            >
              Sign Up
            </button>
            <button
              className={`px-4 py-2 font-semibold rounded-t-md ${
                activeTab === "login"
                  ? "border-b-2 border-primary text-primary"
                  : "border-b-2 border-gray-200 text-gray-600"
              }`}
              onClick={() => setActiveTab("login")}
            >
              Login
            </button>
          </div>

          {/* Forms */}
          <div className="rounded-b-md">
            {error && <p className="text-red-500 text-center mb-2">{error}</p>}
            {success && (
              <p className="text-green-600 text-center mb-2">{success}</p>
            )}

            {activeTab === "signup" ? (
              <>
                <h2 className="text-xl font-bold mb-4 text-center">
                  Create Account
                </h2>

                <form
                  onSubmit={handleSignupSubmit}
                  className="grid grid-cols-1 md:grid-cols-2 gap-4 overflow-y-auto max-h-[60vh] items-start"
                >
                  {/* First Name */}
                  <div className="flex flex-col">
                    <input
                      type="text"
                      name="reg_firstName"
                      placeholder="First Name"
                      value={signupData.reg_firstName}
                      onChange={handleSignupChange}
                      autoComplete="off"
                      className="w-full border p-2 rounded-md"
                    />
                    {errors.reg_firstName && (
                      <p className="text-red-500 text-sm">{errors.reg_firstName}</p>
                    )}
                  </div>

                  {/* Last Name */}
                  <div className="flex flex-col">
                    <input
                      type="text"
                      name="reg_lastName"
                      placeholder="Last Name"
                      value={signupData.reg_lastName}
                      onChange={handleSignupChange}
                      autoComplete="off"
                      className="w-full border p-2 rounded-md"
                    />
                    {errors.reg_lastName && (
                      <p className="text-red-500 text-sm">{errors.reg_lastName}</p>
                    )}
                  </div>

                  {/* Mobile */}
                  <div className="flex flex-col">
                    <input
                      type="tel"
                      name="reg_mobile"
                      placeholder="Mobile"
                      value={signupData.reg_mobile}
                      onChange={handleSignupChange}
                      autoComplete="off"
                      className="w-full border p-2 rounded-md"
                    />
                    {errors.reg_mobile && (
                      <p className="text-red-500 text-sm">{errors.reg_mobile}</p>
                    )}
                  </div>

                  {/* Email */}
                  <div className="flex flex-col">
                    <input
                      type="email"
                      name="reg_email"
                      placeholder="Email"
                      value={signupData.reg_email}
                      onChange={handleSignupChange}
                      autoComplete="off"
                      className="w-full border p-2 rounded-md"
                    />
                    {errors.reg_email && (
                      <p className="text-red-500 text-sm">{errors.reg_email}</p>
                    )}
                  </div>

                  {/* Password */}
                  <div className="flex flex-col">
                    <div className="relative">
                      <input
                        type={showPassword ? "text" : "password"}
                        name="reg_password"
                        placeholder="Password"
                        value={signupData.reg_password}
                        onChange={handleSignupChange}
                        autoComplete="new-password"
                        className="w-full border p-2 rounded-md pr-10"
                      />
                      <button
                        type="button"
                        onClick={() => setShowPassword(!showPassword)}
                        className="absolute inset-y-0 right-0 pr-3 flex items-center text-gray-400 hover:text-gray-600"
                      >
                        {showPassword ? <FiEyeOff size={20} /> : <FiEye size={20} />}
                      </button>
                    </div>
                    {errors.reg_password && (
                      <p className="text-red-500 text-sm">{errors.reg_password}</p>
                    )}
                  </div>

                  {/* Submit Button */}
                  <button
                    type="submit"
                    className="w-full col-span-2 bg-primary font-semibold text-white py-2 rounded-md"
                    disabled={loading}
                  >
                    {loading ? "Registering..." : "Register"}
                  </button>
                </form>

                <button className="w-full text-primary mt-4 border shadow-lg font-semibold py-2 rounded-md text-sm">
                  Sign up with Google
                </button>
              </>
            ) : (
              <>
                <h2 className="text-xl font-bold mb-4 text-center">Login</h2>
                <form className="space-y-3" onSubmit={handleLoginSubmit}>
                  <input
                    type="text"
                    name="email_or_mobile"
                    placeholder="Email or Mobile Number"
                    value={loginData.email_or_mobile}
                    onChange={handleLoginChange}
                    autoComplete="off"
                    className="w-full border p-2 rounded-md"
                  />

                  <div className="relative">
                    <input
                      type={showPassword ? "text" : "password"}
                      name="password"
                      placeholder="Password"
                      value={loginData.password}
                      onChange={handleLoginChange}
                      autoComplete="new-password"
                      className="w-full border p-2 rounded-md pr-10"
                    />
                    <button
                      type="button"
                      onClick={() => setShowPassword(!showPassword)}
                      className="absolute inset-y-0 right-0 pr-3 flex items-center text-gray-400 hover:text-gray-600"
                    >
                      {showPassword ? <FiEyeOff size={20} /> : <FiEye size={20} />}
                    </button>
                  </div>
                  <div className="text-right">
                      <button  type="button" onClick={() => setIsForgotPasswordOpen(true)}>
        Forgot Password?
      </button>

      {/* Forgot Password Modal */}
      <ForgotPassword
        isOpen={isForgotPasswordOpen}
        onClose={() => setIsForgotPasswordOpen(false)}
      />
                  </div>

                  <button
                    type="submit"
                    className="w-full block text-center bg-primary text-white py-2 rounded-md"
                    disabled={loading}
                  >
                    {loading ? "Logging in..." : "Login"}
                  </button>
                </form>
                <button className="w-full mt-4 shadow-lg border py-2 rounded-md text-sm">
                  Login with Google
                </button>
              </>
            )}
          </div>
        </div>
      </div>

      {/* ✅ Mobile View */}
      <div className="md:hidden relative h-full w-full">
        {/* Background Image */}
        <div
          className="absolute inset-0 z-0 w-full h-full"
          style={{
            backgroundImage: `url(${loginLogo})`,
            backgroundSize: "contain",
            backgroundPosition: "top center",
            backgroundRepeat: "no-repeat",
          }}
        />

        {/* Black overlay */}
        <div className="absolute inset-0 bg-black opacity-70 z-0" />

        {/* Bottom Popup */}
        <div className="absolute bottom-0 left-0 right-0 z-20 bg-white rounded-t-3xl px-6 pt-4 pb-6 shadow-2xl max-h-[80%] overflow-y-auto">
          <div className="w-14 h-1.5 bg-gray-300 rounded-full mx-auto mb-4" />

          {/* Tabs */}
          <div className="flex justify-center gap-4 mb-4">
            <button
              className={`px-4 py-2 font-semibold rounded-t-md ${
                activeTab === "signup"
                  ? "border-b-2 border-primary text-primary"
                  : "border-b-2 border-gray-200 text-gray-600"
              }`}
              onClick={() => setActiveTab("signup")}
            >
              Sign Up
            </button>
            <button
              className={`px-4 py-2 font-semibold rounded-t-md ${
                activeTab === "login"
                  ? "border-b-2 border-primary text-primary"
                  : "border-b-2 border-gray-200 text-gray-600"
              }`}
              onClick={() => setActiveTab("login")}
            >
              Login
            </button>
          </div>

          {/* Form content */}
          <div className="pt-2">
            {error && <p className="text-red-500 text-center mb-2">{error}</p>}
            {activeTab === "signup" ? (
              <>
                <h2 className="text-xl font-bold mb-4 text-center">
                  Create Account
                </h2>

                <form
                  className="grid grid-cols-1 md:grid-cols-2 gap-4"
                  onSubmit={handleSignupSubmit}
                >
                  {/* First Name */}
                  <div className="flex flex-col">
                    <input
                      type="text"
                      name="reg_firstName"
                      placeholder="First Name"
                      value={signupData.reg_firstName}
                      onChange={handleSignupChange}
                      autoComplete="off"
                      className="w-full border p-2 rounded-md"
                    />
                    {errors.reg_firstName && (
                      <p className="text-red-500 text-sm mt-1">
                        {errors.reg_firstName}
                      </p>
                    )}
                  </div>

                  {/* Last Name */}
                  <div className="flex flex-col">
                    <input
                      type="text"
                      name="reg_lastName"
                      placeholder="Last Name"
                      value={signupData.reg_lastName}
                      onChange={handleSignupChange}
                      autoComplete="off"
                      className="w-full border p-2 rounded-md"
                    />
                    {errors.reg_lastName && (
                      <p className="text-red-500 text-sm mt-1">
                        {errors.reg_lastName}
                      </p>
                    )}
                  </div>

                  {/* Mobile */}
                  <div className="flex flex-col">
                    <input
                      type="tel"
                      name="reg_mobile"
                      placeholder="Mobile"
                      value={signupData.reg_mobile}
                      onChange={handleSignupChange}
                      autoComplete="off"
                      className="w-full border p-2 rounded-md"
                    />
                    {errors.reg_mobile && (
                      <p className="text-red-500 text-sm mt-1">
                        {errors.reg_mobile}
                      </p>
                    )}
                  </div>

                  {/* Email */}
                  <div className="flex flex-col">
                    <input
                      type="email"
                      name="reg_email"
                      placeholder="Email"
                      value={signupData.reg_email}
                      onChange={handleSignupChange}
                      autoComplete="off"
                      className="w-full border p-2 rounded-md"
                    />
                    {errors.reg_email && (
                      <p className="text-red-500 text-sm mt-1">
                        {errors.reg_email}
                      </p>
                    )}
                  </div>

                  {/* Password */}
                  <div className="flex flex-col">
                    <div className="relative">
                      <input
                        type={showPassword ? "text" : "password"}
                        name="reg_password"
                        placeholder="Password"
                        value={signupData.reg_password}
                        onChange={handleSignupChange}
                        autoComplete="new-password"
                        className="w-full border p-2 rounded-md pr-10"
                      />
                      <button
                        type="button"
                        onClick={() => setShowPassword(!showPassword)}
                        className="absolute inset-y-0 right-0 pr-3 flex items-center text-gray-400 hover:text-gray-600"
                      >
                        {showPassword ? <FiEyeOff size={20} /> : <FiEye size={20} />}
                      </button>
                    </div>
                    {errors.reg_password && (
                      <p className="text-red-500 text-sm mt-1">
                        {errors.reg_password}
                      </p>
                    )}
                  </div>

                  {/* Submit Button */}
                  <div className="col-span-1 md:col-span-2">
                    <button
                      type="submit"
                      className="w-full bg-primary font-semibold text-white py-2 rounded-md"
                      disabled={loading}
                    >
                      {loading ? "Registering..." : "Register"}
                    </button>
                  </div>
                </form>

                <button className="w-full text-primary mt-4 border shadow-lg font-semibold py-2 rounded-md text-sm">
                  Sign up with Google
                </button>
              </>
            ) : (
              <>
                <h2 className="text-xl font-bold mb-4 text-center">Login</h2>
                <form className="space-y-3" onSubmit={handleLoginSubmit}>
                  <input
                    type="text"
                    name="email_or_mobile"
                    placeholder="Email or Mobile Number"
                    value={loginData.email_or_mobile}
                    onChange={handleLoginChange}
                    autoComplete="off"
                    className="w-full border p-2 rounded-md"
                  />

                  <div className="relative">
                    <input
                      type={showPassword ? "text" : "password"}
                      name="password"
                      placeholder="Password"
                      value={loginData.password}
                      onChange={handleLoginChange}
                      autoComplete="new-password"
                      className="w-full border p-2 rounded-md pr-10"
                    />
                    <button
                      type="button"
                      onClick={() => setShowPassword(!showPassword)}
                      className="absolute inset-y-0 right-0 pr-3 flex items-center text-gray-400 hover:text-gray-600"
                    >
                      {showPassword ? <FiEyeOff size={20} /> : <FiEye size={20} />}
                    </button>
                  </div>
                  <div className="text-right">
                     <button  type="button" onClick={() => setIsForgotPasswordOpen(true)}>
        Forgot Password?
      </button>

      {/* Forgot Password Modal */}
      <ForgotPassword 
        isOpen={isForgotPasswordOpen}
        onClose={() => setIsForgotPasswordOpen(false)}
      />
                  </div>

                  <button
                    type="submit"
                    className="w-full block text-center bg-primary text-white py-2 rounded-md"
                    disabled={loading}
                  >
                    {loading ? "Logging in..." : "Login"}
                  </button>
                </form>
                <button className="w-full mt-4 shadow-lg border py-2 rounded-md text-sm">
                  Login with Google
                </button>
              </>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default AuthPage;
